// initial state

import axios from "axios"

const state = () => ({
  meta : [],
  categories : [],
  allCategories : [],
  addNew : false,
  columns : [
    {
      key:"name",
      label: "name",
      display : true,
      table: "product_categories",
      direction : "ASC",
      direction_pos: 0,
    }
  ],
  pagination : {
    currentPage: 1,
    totalPageCount: 1,
  },
  take: 10,
  skip: 0,
  isSaving : false,
  isLoading : false,
})

  // getters
  const getters = {}

  // actions
  const actions = {
    async load({commit, state, rootState}, page = 1) {
      commit("skip", (page - 1) * state.take);
      var pagesize = state.pagination.pagesize;
      commit("isLoading", true);
      await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/productcategories", {
        params: {page: page, pagesize: pagesize, search : '', take: state.take, skip: state.skip, table_columns: state.columns}
      }).then(response => {
        commit("setCategories", response.data.data);
        commit("setMeta", response.data.meta);
        commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
        commit("isLoading", false);
      })
    },

    async loadAll({commit, state, rootState}, data) {
      await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/allproductcategories").then(response => {
        commit("setAllCategories", response.data);
      })
    },

    async update({commit, state, rootState}, data) {
      if (data.category.id == undefined || data.category.id == '') {
        return;
      }
      commit("isSaving", true);
      await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/productcategories/" + data.category.id, data).then(response => {
        commit("update", response.data.data);
      })
      commit("isSaving", false);
    },

    async store({commit, state, rootState}, data){
      commit("isSaving", true);
      await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/productcategories", data).then(response => {
        commit("store", response.data.data);
      })
      commit("isSaving", false);
    },

    async delete({commit, state, rootState}, data) {
      if (data.data.url !== undefined && data.data.ids.length > 0) {
          for (var i = 0; i < data.data.ids.length; i++) {
              var url = data.data.url + "/" + data.data.ids[i];
              await axios.delete(url).then(response => {
                commit("deleteProductCategory", data.data.ids[i]);
              }).catch(error => {
                console.log(error.response.data.message);
              });
          }
      }
    },
  }

  // mutations
  const mutations = {
    clean(state) {
      state.categories = [];
      state.isLoading = false;
    },
    isLoading(state, status) {
      state.isLoading = status;
    },
    setCategories(state, data) {
      state.categories = data;
    },
    setAllCategories(state, data) {
      state.allCategories = data;
    },
    store(state, data) {
      state.categories.unshift(data);
    },
    update(state, data) {
      var index = state.categories.findIndex(item => item.id == data.id);
      if(index >= 0){
        state.categories[index] = data;
      }
    },
    deleteProductCategory(state, id) {
      var index = state.categories.findIndex(item => item.id == id);
      if (index >= 0) {
        state.categories.splice(index, 1);
      }
    },
    pagination(state, object) {
      state.meta.pagination = object;
      if (state.skip <= 0) {
          state.pagination.currentPage = 1;
      } else {
          state.pagination.currentPage = (state.skip / state.take) + 1;
      }
      state.pagination.totalPageCount = Math.ceil(state.meta.pagination.total / state.take);
    },
    skip(state, skip) {
      state.skip = skip;
    },
    isSaving(state, status) {
      state.isSaving = status;
    },
    loadAll(state, status) {
      state.loadAll = status;
    },
    setMeta(state, data) {
      state.meta = data;
    },
    updateColumn(state, column){
        var index = state.columns.findIndex(item => item.key == column.key)
        for(let i in state.columns){
            state.columns[i].direction_pos += 1;
        }
        if(index > -1){
            column.direction_pos = 0;
            state.columns[index] = column;
        }
    }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
